import { z } from 'zod';
import { SALES_ORDER_LINE_CONSTRAINTS } from './constraints.js';
const { label, max } = SALES_ORDER_LINE_CONSTRAINTS.note;
// A blank note is stored as null, so clearing the field in a form clears the column.
export const salesOrderLineNoteSchema = z
    .string()
    .max(max, `${label} must be ${max.toLocaleString('en-US')} characters or less.`)
    .transform((value) => (value.trim() === '' ? null : value))
    .nullable()
    .optional();
//# sourceMappingURL=item-note.js.map